module.exports = __webpack_public_path__ + "img/p8.e3f9eff9.jpg";